import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Alert,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Image } from '../types';
import ImageService from '../services/imageService';
import { chaaviGoldAddImageButtonSx } from '../components/ChaaviVendorDashboardShell';

const ImageManagement: React.FC = () => {
  const [images, setImages] = useState<Image[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const data = await ImageService.getAllImages();
      setImages(data);
    } catch (err) {
      setError('Failed to fetch images');
      console.error('Error fetching images:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" component="h1">
          Image Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ color: '#fff' }} />}
          sx={chaaviGoldAddImageButtonSx}
        >
          Add Image
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image Name</TableCell>
              <TableCell>Theme ID</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Size</TableCell>
              <TableCell>Primary</TableCell>
              <TableCell>Uploaded</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {images.map((image) => (
              <TableRow key={image.imageId}>
                <TableCell>{image.imageName}</TableCell>
                <TableCell>{image.themeId}</TableCell>
                <TableCell>{image.imageType}</TableCell>
                <TableCell>{(image.imageSize / 1024).toFixed(1)} KB</TableCell>
                <TableCell>
                  <Chip
                    label={image.isPrimary ? 'Primary' : 'Secondary'}
                    color={image.isPrimary ? 'primary' : 'default'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {new Date(image.uploadedAt).toLocaleDateString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ImageManagement;
